<template>
  <button @click="confirm" type="submit" >
    <slot></slot>
  </button>
</template>

<script>
import alertify from 'alertify.js'

export default {
  name: 'confirm',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'modal'
    }
  },
  data () {
    return {
      confirmed: false
    }
  },
  methods: {
    confirm (e) {
      if (!this.confirmed) {
        e.preventDefault()
        if (this.type === 'modal') {
          alertify.confirm(this.message, () => {
            this.confirmed = true
            this.$el.click()
          }, () => {
            this.confirmed = false
          })
        }
      } else {
        //
      }
    }
  }
}
</script>
